/**
 * Kleine, gerätelokale Vorlieben (z. B. Filter, Zoom) – pro Nutzer getrennt,
 * damit auf geteilten Geräten nichts zwischen Konten durchsickert.
 */
const PREFIX = "piano:v4";

/** Alte, nicht nutzerbezogene Schlüssel der Vorgängerversion. */
const LEGACY_KEYS = [
  "librarySnapshot:last",
  "libRecent",
  "plLastDetail",
  "libSort",
  "libView",
  "libOrder",
  "libQuery",
  "libCategory",
  "onlyFav",
  "filterCollapsed",
  "libNavMode",
  "playlistMode",
  "viewer.dualMode",
  "annotation-toolbar-pos",
  "jumpMarkers.panel.position",
];

export function cleanupLegacyStorage(): void {
  try {
    for (const key of LEGACY_KEYS) localStorage.removeItem(key);
    for (let i = localStorage.length - 1; i >= 0; i--) {
      const key = localStorage.key(i);
      if (key?.startsWith("libScroll:")) localStorage.removeItem(key);
    }
  } catch {
    // Speicher nicht verfügbar (privater Modus) – nichts zu tun
  }
}

export function readPref<T>(
  userId: string,
  key: string,
  fallback: T,
  valid: (value: unknown) => value is T,
): T {
  try {
    const raw = localStorage.getItem(`${PREFIX}:${userId}:${key}`);
    if (raw === null) return fallback;
    const value: unknown = JSON.parse(raw);
    return valid(value) ? value : fallback;
  } catch {
    return fallback;
  }
}

export function writePref(userId: string, key: string, value: unknown): void {
  try {
    localStorage.setItem(`${PREFIX}:${userId}:${key}`, JSON.stringify(value));
  } catch {
    // voll oder gesperrt – Vorlieben sind optional
  }
}

export const isNumber = (value: unknown): value is number =>
  typeof value === "number" && Number.isFinite(value);
export const isBoolean = (value: unknown): value is boolean => typeof value === "boolean";
export const isString = (value: unknown): value is string => typeof value === "string";
